import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, TrendingUp, ShoppingBag, Database, Code, Server } from 'lucide-react';
import './Services.css';

const services = [
    {
        icon: <Layout size={32} />,
        title: "Webbdesign",
        desc: "Oavsett om du skapar en ny webbplats eller en personlig blogg, erbjuder vi design som verkligen fångar din publiks uppmärksamhet.",
        to: "/webbdesign"
    },
    {
        icon: <TrendingUp size={32} />,
        title: "Syns på Google",
        desc: "Vi maximerar din synlighet online så att kunder i Dalarna hittar dig när de söker – mer trafik och fler förfrågningar.",
        to: "/seo"
    },
    {
        icon: <ShoppingBag size={32} />,
        title: "E-handel",
        desc: "Med våra skräddarsydda e-handelslösningar skapar vi en smidig upplevelse, från produktvisning till betalning och leverans.",
        to: "/e-handel"
    },
    {
        icon: <Database size={32} />,
        title: "Bokning & Kundregister",
        desc: "Låt kunderna boka tid, se sina ordrar eller logga in — vi bygger systemet bakom.",
        to: "/skraddarsydda-system"
    },
    {
        icon: <Code size={32} />,
        title: "Skräddarsydda system",
        desc: "Behöver du en unik funktion? Vi utvecklar skräddarsydda webbapplikationer och system anpassade efter din verksamhet.",
        to: "/skraddarsydda-system"
    },
    {
        icon: <Server size={32} />,
        title: "Drift & Förvaltning",
        desc: "Vi ser till att din hemsida alltid är snabb, säker och uppdaterad så att du kan fokusera på din kärnverksamhet.",
        to: "/#contact"
    }
];

export default function Services() {
    return (
        <section className="services" id="services">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">Tjänster</span>
                    <h2 className="section-title">Vad vi kan hjälpa dig med</h2>
                    <p>Från enkla hemsidor till kompletta e-handelslösningar – vi bygger det din verksamhet behöver för att synas och växa på nätet.</p>
                </div>

                <div className="services-grid">
                    {services.map((s, index) => {
                        const content = (
                            <>
                                <div className="icon-box">
                                    {s.icon}
                                </div>
                                <h3>{s.title}</h3>
                                <p>{s.desc}</p>
                                {s.to && <span className="service-link">Läs mer →</span>}
                            </>
                        );
                        return s.to ? (
                            <Link to={s.to} className="service-card" key={index}>
                                {content}
                            </Link>
                        ) : (
                            <div className="service-card" key={index}>
                                {content}
                            </div>
                        );
                    })}
                </div>

                <p className="services-cta">
                    Osäker på vad du behöver? <Link to="/priskalkylator">Räkna ut ditt pris på 2 minuter</Link> eller <Link to="/#contact">hör av dig</Link> — prototypen är gratis.
                </p>
            </div>
        </section>
    );
}
